import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BasicTabs from '@/components/molecules/BasicTabs';
import ExtraTripsFinishedApprovalsTab from '@/components/organisms/ExtraTripsFinishedApprovalsTab';
import ExtraTripsPendingApprovalsTab from '@/components/organisms/ExtraTripsPendingApprovalsTab';
import ExtraTripsRequestsInProgressTab from '@/components/organisms/ExtraTripsRequestsInProgressTab';

const TABS = ['pending', 'in-progress', 'finished'] as const;

function getTabIndex(tab: string | null): number {
	const index = TABS.indexOf(tab as (typeof TABS)[number]);
	return index === -1 ? 0 : index;
}

export default function ExtraTripsApprovals() {
	const [searchParams, setSearchParams] = useSearchParams();
	const activeTab = getTabIndex(searchParams.get('tab'));

	useEffect(() => {
		const tab = TABS[activeTab];
		const tabOk = searchParams.get('tab') === tab;
		const filterOk =
			tab === 'in-progress' || !searchParams.has('showFromAllFlows');
		if (tabOk && filterOk) return;

		const next = new URLSearchParams(searchParams);
		next.set('tab', tab);
		if (tab !== 'in-progress') next.delete('showFromAllFlows');
		setSearchParams(next, { replace: true });
	}, [activeTab, searchParams, setSearchParams]);

	const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
		const tab = TABS[newValue];
		const next = new URLSearchParams(searchParams);
		next.set('tab', tab);
		if (tab !== 'in-progress') next.delete('showFromAllFlows');
		setSearchParams(next, { replace: true });
	};

	return (
		<div className="h-[90vh] w-full font-graphie">
			<BasicTabs
				value={activeTab}
				onChange={handleTabChange}
				tabsNames={[
					'Aprovações pendentes',
					'Solicitações em andamento',
					'Finalizadas',
				]}
				tabs={[
					<ExtraTripsPendingApprovalsTab key={0} />,
					<ExtraTripsRequestsInProgressTab key={1} />,
					<ExtraTripsFinishedApprovalsTab key={2} />,
				]}
			/>
		</div>
	);
}
